import gql from "graphql-tag";
import client from "apollo/client";

export type DeletableEntity = "AppStatuses" | "AssertionTypes" | "Assertions" | "AssetAttributeModelDefaultValues" | "AssetAttributeSets" | "AssetAttributeUnits" | "AssetAttributeValues" | "AssetAttributes" | "AssetBridgeAssetTags" | "AssetModelBridgeAssetAttributeSets" | "AssetModelTreeNodes" | "AssetModelTrees" | "AssetModels" | "AssetTags" | "AssetTypeTreeNodes" | "AssetTypeTrees" | "AssetTypes" | "Assets" | "AutoUpdateModes" | "Components" | "DeploymentGroupAdministrators" | "DeploymentGroupBridgeAppRevisions" | "DeploymentGroupBridgeDeploymentGroupTags" | "DeploymentGroupBridgeSoftwareRevisions" | "DeploymentGroupTags" | "DeploymentGroups" | "DeviceModelRevisions" | "DeviceModels" | "DeviceTypes" | "EdgeDeviceInstallStateHistories" | "EdgeDeviceInstallStateSnapshots" | "EdgeDeviceInstallStates" | "EdgeDeviceModelBridgeSnapDeclarations" | "EdgeDeviceModels" | "EdgeDevices" | "FleetAdministrators" | "FleetAutoUpdateModes" | "FleetBridgeSnapRevisions" | "Fleets" | "RoleBridgeScopes" | "Roles" | "Scopes" | "SnapCategories" | "SnapDeclarations" | "SnapDeltas" | "SnapNamePolicies" | "SnapRevisions" | "SnapStatuses" | "SnapTypes" | "SnapVisibilityPolicies" | "StoreSettings" | "Tenants" | "UserBridgeRoles" | "UserSessions" | "Users" | "Vulnerabilities" | "VulnerabilityFindings"; 

export interface GenericDeleteProps {
  entity: DeletableEntity;
  afterDelete?: (data: any) => void;
}

export type IdType = string[] | string;
export type DeleteItemsFucType = (idsIn: IdType) => Promise<IdType>;

export default ({ entity, afterDelete }: GenericDeleteProps) => async (idsIn: IdType) => {
  const ids = typeof idsIn === "string" ? [idsIn] : idsIn;

  const mutation = gql`mutation GenericDelete${entity}($ids:[UUID!]!){
        result: delete${entity}(ids:$ids){
           id
           __typename
         }
       }`;

  const result = await client.mutate({
    mutation,
    variables: { ids },
  });

  const deletedIds: { id: string; __typename: string }[] = result.data?.result.map((row: { id: string }) => row.id);

  if (afterDelete) afterDelete(deletedIds);

  return deletedIds;
};